module.exports = __webpack_public_path__ + "img/shoppingcar.c33a7858.svg";